import React from "react";
import { TRIGGERS } from "../../../constants/sequence";
import TriggerListCard from "./TriggerListCard";
import { useSelector } from "react-redux";

export default function TriggerList({ onSelectTrigger }) {
  const featureFlags = useSelector((state) => state.app.featureFlags);
  const isApiTriggerEnabled = featureFlags?.api_trigger_feature;
  const isKeywordTriggerEnabled = featureFlags?.keyword_trigger_feature;

  return (
    <div className="w-full h-full rounded-3xl">
      <div className="w-full px-5 py-2.5 rounded-t-xl bg-gradient-to-r from-[#9879FF] to-[#FFAC97]">
        <div></div>
        <div className="text-white">Triggers</div>
      </div>
      <div className="w-full h-full px-5 pb-4 rounded-b-3xl bg-white">
        {TRIGGERS?.map((t) => {
          const show = t?.list?.filter((l) => {
            if (l?.disabled) return false;
            if (l?.key === "API_TRIGGER" && !isApiTriggerEnabled) return false;
            if (l?.key === "KEYWORD_TRIGGER" && !isKeywordTriggerEnabled) return false;
            return true;
          });

          if (show?.length === 0) return null;

          return (
            <div key={t?.id} className="">
              <div className="text-xs weight-semibold py-3.5 text-[var(--font-600)]">
                {t?.title}
              </div>
              <div className="grid grid-cols-1 gap-3">
                {t?.list?.map((l) => {
                  if (l?.disabled) return null;
                  if (l?.key === "API_TRIGGER" && !isApiTriggerEnabled) return null;
                  if (l?.key === "KEYWORD_TRIGGER" && !isKeywordTriggerEnabled) return null;

                  return (
                    <div
                      key={l?.id}
                      className="transition-all duration-200 hover:shadow-md rounded-lg overflow-hidden"
                      onClick={(event) => {
                        event.stopPropagation();
                        if (!l?.disabled) onSelectTrigger(l);
                      }}
                    >
                      <TriggerListCard data={l} />
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
